<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul
        class="items-center gap-x-3 grid"
        style="grid-template-columns: 1fr auto"
      >
        <el-form-item
          label="户名"
          prop="name"
          :rules="[{ required: true, message: '请输入户名', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </ul>
      <ul class="items-center gap-x-3 grid grid-cols-2">
        <el-form-item
          label="账号"
          prop="account"
          :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.account" type="number"></el-input>
        </el-form-item>
        <el-form-item
          label="开户行"
          prop="opening_bank"
          :rules="[
            { required: true, message: '请输入开户行', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.opening_bank"></el-input>
        </el-form-item>
      </ul>
      <el-form-item label="备注">
        <el-input
          v-model="state.model.remark"
          type="textarea"
          :autosize="{
            minRows: 3,
          }"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  supplier_bank_account_detail,
  supplier_bank_account_add,
  supplier_bank_account_edit,
} from "@/http/supplier";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    supplier_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        supplier_id: props.supplier_id,
        status: 1,
      },
    });
    onMounted(() => {
      if (props.id) {
        supplier_bank_account_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.contract_times = [
              data.contract_time,
              data.contract_time_end,
            ];
          }
        });
      }
    });
    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            supplier_bank_account_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            supplier_bank_account_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
